<template>
    <div class="ml-auto mr-auto" :class="{ 'col-lg-5 col-md-8': !isAuthenticated, 'col-md-8': isAuthenticated }">
        <template v-if="!isAuthenticated">
            <div class="auth__box" :class="{ 'is-loading': isLoading }">
                <h1>Mijn opname</h1>
                <p class="mt-2">Voer uw toegangscode in om uw opname te bekijken.</p>

                <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">
                    <div class="alert alert-danger" v-if="error" v-text="error"></div>

                    <div class="form-group" :class="{ 'is-invalid': form.errors.has('code') }">
                        <label for="code">Toegangscode</label>
                        <input type="text" class="form-control" id="code" aria-describedby="code" placeholder="Toegangscode.." v-model="form.code">
                    </div>
                    <p class="form-error" v-if="form.errors.has('code')" v-text="form.errors.get('code')"></p>

                    <button type="submit" class="btn btn-secondary">Opname bekijken</button>
                </form>
            </div>
        </template>

        <template v-if="isAuthenticated">
            <div class="auth__box" v-if="isAuthenticated">
                <h3>{{ property.street }} {{ property.housenumber ? property.housenumber : '' + ( property.housenumber_addition ? property.housenumber_addition : '' ) }}</h3>
                <p>{{ property.zipcode ? property.zipcode + ', ' : '' }} {{ property.city }}</p>

                <hr>

                <template v-if="getScheduledInspection.length === 0 && property.reports.length === 0">
                    <div class="alert alert-warning">
                        Er zijn (nog) geen gegevens bekend voor dit object.
                    </div>
                </template>

                <template v-if="getScheduledInspection.length > 0">
                    <h4>Planning</h4>

                    <div class="alert alert-info my-4">Komt één van onderstaande data niet uit of heeft u vragen? Neem dan contact met ons op via <a href="mailto:info@tb-expertise.nl">info@tb-expertise.nl</a> of bel naar <a href="tel:0031165513554">+31 (0) 165 51 35 54</a>.</div>

                    <table class="table table-striped">
                        <tr v-for="schedule in getScheduledInspection" :key="schedule.id">
                            <td width="50%">{{ schedule.type | formatType }}</td>
                            <td align="right">{{ schedule.dates | formatDates }}</td>
                        </tr>
                    </table>
                    <hr>
                </template>

                <template v-if="property.reports.length > 0">
                    <h4 class="mt-4">Rapporten</h4>

                    <table class="table table-striped mt-3">
                        <tr v-for="report in property.reports" :key="report.id">
                            <td>{{ report.name }}</td>
                            <td align="right"><a href="#" @click.prevent="downloadReport(report)">Downloaden</a></td>
                        </tr>
                    </table>
                </template>


                <router-link :to="{ name: 'onlineDossier', params: { token: property.token } }" target="_blank" class="btn btn-primary">Online dossier bekijken</router-link>

            </div>
        </template>
    </div>
</template>

<script>
	import moment from 'moment-timezone'
	import Form from '@/utilities/Form'
	import { INSIGHT_LOGIN } from '@/store/modules/insight'

	export default {
		data () {
			return {
				isAuthenticated: false,
				property: {},
				isLoading: false,
				error: null,
				success: null,
				form: new Form({
					code: null,
				}),
			}
		},

		computed: {
			getScheduledInspection () {
				return this.property.schedule.filter((schedule) => {
					return (
						schedule.status !== 3
					)
				})
			},

			getReports () {
				return this.property.reports
			},
		},

		methods: {
			onSubmit () {
				this.isLoading = true

				this.$store.dispatch(INSIGHT_LOGIN, this.form.data()).then((response) => {
					this.isLoading = false
					this.property = response
					this.isAuthenticated = true
				}).catch(() => {
					this.isLoading = false
					this.error = 'De opgegeven code is onjuist.'
				})
			},

			downloadReport (report) {
				window.axios({
					url: process.env.VUE_APP_API_URL + '/insight/download/' + this.property.token + '/' + report.id,
					method: 'GET',
					responseType: 'arraybuffer',
				}).then((response) => {
					let blob = new Blob([response.data], { type: 'application/pdf' })

					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveOrOpenBlob(blob)
						return
					}

					let data = window.URL.createObjectURL(blob)
					let link = document.createElement('a')

					link.href = data
					link.download = report.name
					link.click()

					setTimeout(function () {
						window.URL.revokeObjectURL(data)
					}, 100)
				})
			},
		},

		filters: {
			formatType (value) {
				let types = [
					'Vooropname',
					'Tussenopname',
					'Extra opname',
					'Eindopname',
				]

				return types[value - 1]
			},

			formatDates (value) {
				return value.map((date) => {
					console.log(date.date)
					return moment(date.date).locale('nl').format('LL')
				}).join(', ')
			},
		},
	}
</script>